module.exports = __webpack_public_path__ + "media/customize/banner-classic-bottom-59aebb41.svg";